import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import Main from './components/Main';
import { store } from './store';
import './App.scss';

const App = () => (
  <ReduxProvider store={store}>
    <Main />
  </ReduxProvider>
);

export default App;
